module.exports = __webpack_public_path__ + "static/media/cab-q28.ec4e2375.jpg";